import { api } from "@/lib/axios";

interface expenseCreationProps {
  expenseDescription: string;
  expenseAmount: number;
  paidTo: string;
  expenseDate: Date;
  paymentMethod: string;
  companyId: string;
}

export async function createExpense({
  expenseDescription,
  expenseAmount,
  paidTo,
  expenseDate,
  paymentMethod,
  companyId,
}: expenseCreationProps) {
  return await api.post(`/expenses/${companyId}`, {
    expenseDescription,
    expenseAmount,
    paidTo,
    expenseDate,
    paymentMethod,
  });
}
